import HttpClienteToken from '../../services/HttpClientToken';

import { CiudadProps, ObtenerCiudadesParams } from '../../interfaces/catalogos/CiudadInterface';

export const Ciudades = () => {

    return new Promise<CiudadProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if ( data ) {
            const { token } = data;

            HttpClienteToken.get('/Api/Ciudad/', token)
            .then(({ data }: { data: CiudadProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        }

    });

}

export const ObtenerCiudad = ( params: ObtenerCiudadesParams ) => {

    return new Promise<CiudadProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if ( data ) {

            const { token } = data;

            HttpClienteToken.post('/Api/Ciudad/ObtenerCiudades', params, token )
            .then(({ data }: { data: CiudadProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });

        }

    });

}

export const ActualizarCiudad = ( params: CiudadProps ) => {

    return new Promise<CiudadProps>(( resolve, eject ) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if ( data ) {
            const { token } = data;

            HttpClienteToken.post('/Api/Ciudad/Actualizar', params, token)
            .then(({ data }: { data: CiudadProps }) => {
                resolve(data);
            })
            .catch(() => {
                resolve({
                    idCiudad: 0,
                    clave: '',
                    descripcion: '',
                    idEstado: 0,
                    idMunicipio: 0,
                    activo: false,
                    estado: undefined,
                    municipio: undefined
                });
            });

        }

    });

}

export const AgregarCiudad = ( params: CiudadProps ) => {

    return new Promise<CiudadProps>( ( resolve, eject ) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if ( data ) {

            const { token } = data;

            HttpClienteToken.post('/Api/Ciudad/Agregar', params, token)
            .then(({ data }: { data: CiudadProps }) => {
                resolve(data);
            })
            .catch(() => {
                resolve({
                    idCiudad: 0,
                    clave: '',
                    descripcion: '',
                    idEstado: 0,
                    idMunicipio: 0,
                    activo: false,
                    estado: undefined,
                    municipio: undefined
                });
            });
        }            

    });

}